import { render } from "./LayoutFullVideo.vue?vue&type=template&id=00343ace"
import script from "./LayoutFullVideo.vue?vue&type=script&lang=js"
export * from "./LayoutFullVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__